import { Button, HelpQuestion } from '@taskall/react';
import { Card, EmptyState } from '@taskall/ui';
import { useNavigate } from 'react-router-dom';

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="grid min-h-[60vh] place-items-center">
      <Card className="w-full max-w-lg">
        <EmptyState
          icon={HelpQuestion}
          title="Página não encontrada"
          description="O endereço acessado não existe ou foi movido."
          action={<Button onClick={() => navigate('/dashboard')}>Ir para o painel</Button>}
        />
      </Card>
    </div>
  );
}
